<template>
	<div id="contextmenu">
		<ul>
			<li><a v-on:click="addNewFolder" href="#!">Neuer Unterordner</a></li>
<!-- 			<li><a href="#!">Alle als gelesen markieren</a></li> -->
		</ul>
	</div>
</template>
<script>
	
import swal from 'sweetalert';	
	
export default {
		name: "Contextmenu",
		
		methods: {
			
			addNewFolder(e){
				e.preventDefault();
				
				console.log( this.$store.state.accountContext );
				
				var acc =  this.$store.state.accountContext;
				
			swal({
			  text: 'Wie soll der neue Unterordner unter "'+ this.$store.state.accountContext.account +'" heißen?',
			  content: "input",
			  button: {
			    text: "Ordner anlegen",
			    closeModal: false,
			  },
			})
			.then(name => {
				if (!name) throw null;
 
				console.log( { name: name, account: acc } );
 
				this.$socket.emit('addNewFolder', {  name: name, account: acc } );
				swal.stopLoading();
			    swal.close();				
			})
			.catch(err => {
			  if (err) {
			    swal("Fuck, so geht das nicht!", "error");
			  } else {
			    swal.stopLoading();
			    swal.close();
			  }
			});




				//console.log( this.$store.state.accountContext.account );
				//this.$socket.emit('addNewFolder', this.$store.state.accountContext );
				
			}
		}
}
</script>
<style>
	#contextmenu { position: fixed; z-index: 110; top: 135px; left: 178px; } 
	#contextmenu:before { content: " "; position: absolute; top: 10px; left: -8px; border-left: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-right: 12px solid #fff;  }
	#contextmenu ul { display: block; background: #fff;  width: 14em; height: auto; box-shadow: 0 0 8px rgba(0,0,0,0.6); border-radius: 3px; maring: 0; padding: 0; list-style: none; padding: 0.433333em 0; }
	#contextmenu ul li { display: block; padding: 0 0.4333333em; }
	#contextmenu ul li a { display: block; padding: 0.433333em 0.9333333em; font-size: 0.9rem;  text-align: left; }
	#contextmenu ul li a:hover { background: #eee; }
	#contextmenu { display: none; }
	#contextmenu.open { display: block; }
</style>